import React from "react";
import CreateInbox from "./modal/createInbox";

const Inbox = () => {
  return (
    <>
      <CreateInbox />
    </>
  );
};

export default Inbox;
